<template>
    <div>
        <load v-if="loading" mode="table" message="Carregando parâmetros" />
        <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
        <div v-if="success" class="alert alert-success" role="status">Parâmetros salvos com sucesso.</div>
        <button v-if="loadFailed" class="btn btn-secondary" @click="load">Tentar novamente</button>
        <form v-if="!loading && !loadFailed" @submit.prevent="save">
            <div class="row">
                <div v-for="field in fields" :key="field" class="col-md-6 form-group">
                    <label :for="`connected-app-${field}`">{{ field }}</label>
                    <input :id="`connected-app-${field}`" v-model.trim="form[field]"
                        class="form-control" :type="field === 'secret_id' ? 'password' : (field === 'base_url' ? 'url' : 'text')"
                        :placeholder="field === 'secret_id' && hasSecretId ? '****' : ''"
                        :maxlength="field === 'base_url' ? 2048 : 255" :disabled="saving"
                        :required="field !== 'secret_id' || !hasSecretId" />
                    <small v-if="field === 'secret_id' && hasSecretId" class="form-text text-muted">Deixe em branco para manter o valor salvo.</small>
                    <small v-if="errors[field]" class="text-danger">{{ errors[field][0] }}</small>
                </div>
                <div class="col-md-6 form-group">
                    <label for="connected-app-secret">secret_value</label>
                    <input id="connected-app-secret" v-model="form.secret_value" type="password"
                        class="form-control" autocomplete="new-password" maxlength="4096"
                        :placeholder="hasSecret ? '****' : ''" :required="!hasSecret" :disabled="saving" />
                    <small v-if="hasSecret" class="form-text text-muted">Deixe em branco para manter o segredo salvo.</small>
                    <small v-if="errors.secret_value" class="text-danger">{{ errors.secret_value[0] }}</small>
                </div>
            </div>
            <div class="text-right">
                <button type="submit" class="btn btn-success" :disabled="saving">
                    <i class="mdi mdi-content-save" /> {{ saving ? 'Salvando...' : 'Salvar' }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fields: ['workbook', 'view', 'base_url', 'site', 'client_id', 'secret_id'],
            form: { workbook: '', view: '', base_url: '', site: '', client_id: '', secret_id: '', secret_value: '' },
            loading: true, saving: false, loadFailed: false, hasSecret: false, hasSecretId: false,
            error: '', success: false, errors: {},
        };
    },
    mounted() { this.load(); },
    methods: {
        apply(data) {
            this.fields.forEach(field => { this.form[field] = data && field !== 'secret_id' ? data[field] : ''; });
            this.hasSecretId = Boolean(data && data.has_secret_id);
            this.form.secret_value = '';
            this.hasSecret = Boolean(data && data.has_secret_value);
        },
        async load() {
            this.loading = true;
            this.error = '';
            this.loadFailed = false;
            try {
                const response = await axios.get('api/dashboard/connected-app');
                this.apply(response.data);
            } catch (error) {
                this.loadFailed = true;
                this.error = 'Não foi possível carregar os parâmetros do Connected App.';
            } finally { this.loading = false; }
        },
        async save() {
            this.saving = true;
            this.success = false;
            this.error = '';
            this.errors = {};
            try {
                const response = await axios.post('api/dashboard/connected-app', this.form);
                this.apply(response.data);
                this.success = true;
            } catch (error) {
                const data = error.response && error.response.data;
                this.errors = (data && data.errors) || {};
                this.error = Object.keys(this.errors).length
                    ? 'Verifique os campos informados.' : 'Não foi possível salvar os parâmetros do Connected App.';
            } finally { this.saving = false; }
        },
    },
};
</script>
